import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// GET ALL
export const fetchSpecialities = createAsyncThunk(
  "speciality/fetchSpecialities",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_SPECIALITIES, {
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// CREATE
export const createSpeciality = createAsyncThunk(
  "speciality/createSpeciality",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_SPECIALITY,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// UPDATE
export const updateSpeciality = createAsyncThunk(
  "speciality/updateSpeciality",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_SPECIALITY,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// DELETE
export const deleteSpeciality = createAsyncThunk(
  "speciality/deleteSpeciality",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.delete(
        `${API_ENDPOINTS.DELETE_SPECIALITY}?specialityId=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// SEARCH
export const searchSpeciality = createAsyncThunk(
  "speciality/searchSpeciality",
  async (name, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.SEARCH_SPECIALITY}?specialityName=${name}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const SpecialitySlice = createSlice({
  name: "speciality",
  initialState: {
    fetch: { data: [], loading: false, error: null },
    create: { data: null, loading: false, error: null },
    update: { data: null, loading: false, error: null },
    delete: { data: null, loading: false, error: null },
    search: { data: [], loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchSpecialities.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
      })
      .addCase(fetchSpecialities.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
      })
      .addCase(fetchSpecialities.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
      })

      // CREATE
      .addCase(createSpeciality.pending, (state) => {
        state.create.loading = true;
        state.create.error = null;
      })
      .addCase(createSpeciality.fulfilled, (state, action) => {
        state.create.loading = false;
        state.create.data = action.payload;
      })
      .addCase(createSpeciality.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
      })

      // UPDATE
      .addCase(updateSpeciality.pending, (state) => {
        state.update.loading = true;
        state.update.error = null;
      })
      .addCase(updateSpeciality.fulfilled, (state, action) => {
        state.update.loading = false;
        state.update.data = action.payload;
      })
      .addCase(updateSpeciality.rejected, (state, action) => {
        state.update.loading = false;
        state.update.error = action.payload;
      })

      // DELETE
      .addCase(deleteSpeciality.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteSpeciality.fulfilled, (state, action) => {
        state.delete.loading = false;
        state.delete.data = action.payload;
      })
      .addCase(deleteSpeciality.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
      })

      // SEARCH
      .addCase(searchSpeciality.pending, (state) => {
        state.search.loading = true;
        state.search.error = null;
      })
      .addCase(searchSpeciality.fulfilled, (state, action) => {
        state.search.loading = false;
        state.search.data = action.payload || [];
      })
      .addCase(searchSpeciality.rejected, (state, action) => {
        state.search.loading = false;
        state.search.error = action.payload;
      });
  },
});

export default SpecialitySlice.reducer;
